import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredIds = [1, 3, 6, 9];
const featuredArticles = articles.filter((a) => featuredIds.includes(a.id));

export default function FeaturedArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="container-custom">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精选爆料
            </h2>
            <p className="mt-2 text-sm text-foreground-600">编辑团队为你精选的优质内容</p>
          </div>
          <Link
            to="/category/zuixin-baoliao"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-56 md:w-64 h-48 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-between min-w-0">
                <div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded text-xs font-medium">
                      {article.categorySlug === 'shendu-diaocha' ? '深度调查' :
                       article.categorySlug === 'wangyou-tougao' ? '网友投稿' :
                       article.categorySlug === 'zuixin-baoliao' ? '最新爆料' : article.categorySlug}
                    </span>
                    <span className="text-xs text-foreground-400">{article.date}</span>
                  </div>
                  <h3 className="mt-2 font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
                <div className="mt-4 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.viewCount.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-1-line"></i> {article.commentCount.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i> {article.author}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/zuixin-baoliao"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer"
          >
            查看全部内容 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}